import Table from "@/components/Table/table";
import { useCase } from "@/features/case/use-case";
import { useColumnCommentHistoryDefs } from "@/features/claimsummary/summary/constant/claimFormHeaderConst";
import {
  useGetCommentHistoryViewApiDataQuery,
  useCreateCommentMutation,
} from "@/services/claimSummary/caseSummaryReducer";

import {
  MotifButton,
  MotifProgressLoader,
} from "@ey-xd/motif-react";

import { useEffect, useState } from "react";
import DeleteModal from "@/components/Modal/DeleteModal/DeleteModal";
import EditCommentModal from "@/components/Modal/EditCommentModal/EditCommentModal";
import {
  useDeleteCommentMutation,
  useUpdateCommentMutation,
} from "@/services/comments/commentsReducer";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { havingDeletePermission, havingEditPermission } from "@/utility/common";
import { GetCommonDeleteImgButton } from "@/components/Images/CommonImages";
import InputBox from "@/components/Form/InputBox/InputBox";
type commentHistoryConst = {
  data: {
    comment: string;
    commentCreatedOn: string;
    commentCreatedBy: string;
  };
};

export const TitleComplement = () => {
  return <></>;
};
export const CommentHistory = ({ entityType, dataId }: any) => {
  const caseData = useCase();
  // @ts-ignore
  const { t } = useTranslation();
  const getDataByUrl = { caseId: caseData.caseId, claimId: dataId };
  const [commentText, setCommentText] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selectedComment, setSelectedComment] = useState<any>(null);
  const [deleteComment, { isLoading: deleteLoading }] =
    useDeleteCommentMutation();
  const [updateComment, { isLoading: updateLoading }] =
    useUpdateCommentMutation();
  const { data, isLoading, refetch } =
    useGetCommentHistoryViewApiDataQuery(getDataByUrl);
  const [createComment, { isLoading: commentLoading }] =
    useCreateCommentMutation();
  let commentData = {
    caseId: caseData.caseId,
    entityId: dataId,
    entityType: entityType,
    commentMsg: commentText,
  };
  const [commentTextLength, setCommentTextLength] = useState(0);
  const permissions = useSelector((state: any) => state.permissions);
  let userPermission: string[] = [];

  switch (entityType) {
    case 1:
      userPermission = permissions.Creditor;
      break;
    case 2:
      userPermission = permissions.Claim;
      break;
    case 3:
      userPermission = permissions.ClaimItem;
      break;
    case 4:
      userPermission = permissions.Creditor;
      break;
    case 5:
      userPermission = permissions.Case;
      break;
    default:
      userPermission = [];
  }

  useEffect(() => {
    if (!showEdit && !showDelete) {
      refetch();
    }
  }, [showEdit, showDelete, refetch]);

  const handleSaveEdit = (updatedComment: any) => {
    updateComment({
      commentId: updatedComment.commentId,
      commentMsg: updatedComment.commentMsg,
    }).then(() => {
      setShowEdit(false);
      refetch();
    });
  };

  const handleEdit = (commentData: any) => {
    setSelectedComment(commentData);
    setShowEdit(true);
  };

  const handleDelete = () => {
    deleteComment({
      CommentId: selectedComment?.commentId,
    }).then(() => {
      setShowDelete(false);
      refetch();
    });
  };

  async function postComment() {
    const response = await createComment(commentData);
    if (response.hasOwnProperty("data")) {
      setCommentText("");
      setCommentTextLength(0);
      refetch()
    }
  }

  const customActionHeader = {
    postedOnRenderer: function (param: commentHistoryConst) {
      return <>{param.data.commentCreatedOn}</>;
    },
    actionRenderer: function (props: any) {
      return (
        <>
          <div className="ccwp_comment_customheader_wrapper">
            {/* { 
          //@ts-ignore
          havingEditPermission(userPermission) && 
            <MotifButton
              onClick={() => handleEdit(props.data)}
              size="small"
              type="button"
              variant={EDIT_IMG_VARIANT}
            >
             {getCommonEditImg()}
            </MotifButton>
          }
          &nbsp;&nbsp; */}
            {
              //@ts-ignore
              havingDeletePermission(userPermission) && (
                <GetCommonDeleteImgButton
                  onClick={() => {
                    setSelectedComment(props.data);
                    setShowDelete(true);
                  }}
                ></GetCommonDeleteImgButton>
              )
              // <CommonTooltipWrapper tooltipTitle={t("global.globalActions.delete")}>
              // <MotifButton
              //   onClick={() => {
              //     setSelectedComment(props.data);
              //     setShowDelete(true);
              //   }}
              //   size="small"
              //   type="button"
              //   variant={DELETE_IMG_VARIANT}
              // >
              //   {getCommonDeleteImg()}
              // </MotifButton>
              // </CommonTooltipWrapper>
            }
          </div>
        </>
      );
    },
  };
  const columnCommentHistoryDefs = useColumnCommentHistoryDefs(
    caseData?.abbreviation,
    handleEdit,
    userPermission
  );
  return (
    <div className="mar-b-20">
      <h3 className="ccwp_comment_heading">
        {t("commonComponent.comment.title")}
      </h3>
      {havingEditPermission(userPermission) && (
        <div className="motif-row align-items-center">
          <div className="motif-col-lg-5">
            <div>
              <InputBox
                id="input"
                placeholder={t("commonComponent.comment.commentPlaceholder")}
                onChange={(event: any) => {
                  setCommentTextLength(event.target.value.length);
                  setCommentText(event.target.value);
                }}
                value={commentText}
                isTextArea={true}
                maxLength="2000"
              />
            </div>
            <div className="text-right">{`${commentTextLength}/${2000}`}</div>
          </div>
          <MotifButton
            onClick={() => {
              postComment();
            }}
            size="small"
            type="submit"
            variant="primary"
            disabled={!commentText ? true : false}
            loading={commentLoading}
            style={{ marginBottom: "16px" }}
          >
            {t("global.globalActions.post")}
          </MotifButton>
        </div>
      )}
      {isLoading ? (
        <MotifProgressLoader show variant="default" className="mar-b-20" />
      ) : (
        <Table
          columnDefs={columnCommentHistoryDefs}
          cellRenderers={data}
          TitleComplement={TitleComplement}
          title={"commonComponent.comment.tableTitle"}
          description={"commonComponent.comment.tableDescription"}
          caseRenderers={customActionHeader}
          pagination={false}
          overlayNoRowsTemplate={t("global.globalNotifications.noRecords")}
        />
      )}

      <DeleteModal
        message={t("commonComponent.comment.deleteMessage")}
        isVisible={showDelete}
        setIsVisible={setShowDelete}
        cancelBtnHandler={() => setShowDelete(false)}
        yesBtnHandler={handleDelete}
        deleteLoading={deleteLoading}
      />

      {showEdit && (
        <EditCommentModal
          show={showEdit}
          setShow={setShowEdit}
          comment={selectedComment}
          onSave={handleSaveEdit}
          isEdit={true}
          updateLoading={updateLoading}
        />
      )}
    </div>
  );
};
